import moment from 'moment';
import React from 'react';
import { CardTitle, Label, Table } from 'reactstrap';
import { GroupedDisbursement } from '~/types/disbursements';
import { NoDataCard } from '../Campaign/components/NoDataCard';
import { tr } from 'date-fns/locale';

const TITLE = `You don't have any disbursements yet.`;
const BODY = `Click <a href="/requests">here</a> to submit your first fund request.`;

const DisbursementsTable = ({
    groupedDisbursements,
}: {
    groupedDisbursements: GroupedDisbursement[];
}) => {
    const getTotalAmount = () => {
        let total = 0;
        groupedDisbursements.forEach((grouped) => {
            total += grouped.amount;
        });
        return total.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        });
    };

    return (
        <>
            <Table className='min-w-full bg-white'>
                <thead>
                    <tr className='d-none d-md-table-row'>
                        <th className='px-1'>Check #</th>
                        <th className='px-1'>Vendor</th>
                        <th className='px-1'>Payee Address</th>
                        <th className='px-1'>Date</th>
                        <th className='px-1 text-end'>Amount</th>
                    </tr>
                </thead>

                <tbody>
                    {groupedDisbursements?.length > 0 ? (
                        groupedDisbursements.map(
                            (groupedDisbursement, index) => (
                                <React.Fragment key={index}>
                                    <tr>
                                        <td colSpan={5} className='px-1 py-2'>
                                            <CardTitle tag={'h6'}>
                                                {groupedDisbursement.name}
                                            </CardTitle>
                                        </td>
                                    </tr>
                                    {groupedDisbursement.disbursements.map(
                                        (item, subIndex) => (
                                            <React.Fragment>
                                                {/* Render this component only if the screen size is mobile */}
                                                <tr
                                                    key={`${index}-${subIndex}`}
                                                    className='d-md-none'
                                                >
                                                    <td
                                                        colSpan={5}
                                                        className='px-1'
                                                    >
                                                        <div>
                                                            <span>Check #</span>{' '}
                                                            {item.doc_number}
                                                        </div>
                                                        <div className='py-2'>
                                                            {
                                                                item.check_address !== undefined ? item.check_address : groupedDisbursement.address
                                                            }
                                                        </div>
                                                        <div className='d-flex justify-content-between'>
                                                            <div>
                                                                {moment(
                                                                    item.effective_date
                                                                ).format('L')}
                                                            </div>
                                                            <div>
                                                                {parseFloat(item.amount).toLocaleString(
                                                                    'en-US',
                                                                    {
                                                                        style: 'currency',
                                                                        currency: 'USD',
                                                                    }
                                                                )}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>

                                                {/* Render this component if the screen size is not mobile */}
                                                <tr
                                                    key={`${index}-${subIndex}-non-mobile`}
                                                    className='d-none d-md-table-row'
                                                >
                                                    <td className='px-1 py-2'>
                                                        {item.doc_number}
                                                    </td>
                                                    <td className='px-1 py-2'>
                                                        {
                                                            groupedDisbursement.name
                                                        }
                                                    </td>
                                                    <td className='px-1 py-2'>
                                                        {
                                                            item.check_address !== undefined ? item.check_address : groupedDisbursement.address
                                                        }
                                                    </td>
                                                    <td className='px-1 py-2'>
                                                        {moment(
                                                            item.effective_date
                                                        ).format('L')}
                                                    </td>
                                                    <td className='px-1 py-2 text-end'>
                                                        {parseFloat(item.amount).toLocaleString(
                                                            'en-US',
                                                            {
                                                                style: 'currency',
                                                                currency: 'USD',
                                                            }
                                                        )}
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        )
                                    )}
                                    <tr>
                                        <td
                                            className='px-1 py-2 d-none d-md-table-cell'
                                            colSpan={3}
                                        ></td>
                                        <td className='px-1 py-2' colSpan={1}>
                                            <strong>Total</strong>
                                        </td>
                                        <td className='px-1 py-2 text-end'>
                                            <strong>
                                                {groupedDisbursement.amount.toLocaleString(
                                                    'en-US',
                                                    {
                                                        style: 'currency',
                                                        currency: 'USD',
                                                    }
                                                )}
                                            </strong>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            )
                        )
                    ) : (
                        <tr>
                            <td colSpan={5}>
                                <NoDataCard title={TITLE} body={BODY} />
                            </td>
                        </tr>
                    )}
                    {groupedDisbursements?.length > 0 && (
                        <tr>
                            <td
                                className='px-1 py-2 d-none d-md-table-cell'
                                colSpan={3}
                            ></td>
                            <td className='px-1 py-2'>
                                <strong>Total Requested</strong>
                            </td>
                            <td className='px-1 py-2 text-end'>
                                <strong>{getTotalAmount()}</strong>
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </>
    );
};

export default DisbursementsTable;
